var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { TextField } from '@mui/material';
import { inject, observer } from 'mobx-react';
var CustomFieldNumber = /** @class */ (function (_super) {
    __extends(CustomFieldNumber, _super);
    function CustomFieldNumber(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            value: props.field.value
        };
        return _this;
    }
    Object.defineProperty(CustomFieldNumber.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var error = this.props.field.value.length === 0 && this.props.field.isMandatory;
            return (_jsx(TextField, { variant: "outlined", type: "number", fullWidth: true, InputLabelProps: { shrink: true }, onChange: function (e) { return _this.onValueChanged(e); }, value: this.props.field.value, label: this.props.label, required: this.props.field.isMandatory, error: error }, void 0));
        }
    });
    Object.defineProperty(CustomFieldNumber.prototype, "onValueChanged", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            var _a;
            (_a = this.props.fieldsStore) === null || _a === void 0 ? void 0 : _a.updateFieldValue(this.props.field, e.target.value);
        }
    });
    CustomFieldNumber = __decorate([
        inject('fieldsStore'),
        observer
    ], CustomFieldNumber);
    return CustomFieldNumber;
}(React.Component));
export default CustomFieldNumber;
